<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Senseway</h2>
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="macAddress">
              <the-mask
                class="el-input__inner"
                v-model="query.macAddress"
                :masked="true"
                mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)"
                @keyup.enter.native="load"
                :tokens="hexTokens"
              />
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
                v-model="query.customer"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="version">
              <el-input
                @keyup.enter.native="load"
                placeholder="Please input"
                v-model="query.version"
              ></el-input>
            </el-form-item>
            <el-form-item label="Connection">
              <el-select
                v-model="query.connectionStatus"
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in connectionStatusSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.gateways"
            class="border"
          >
            <el-table-column type="index" label="Id">
              <template slot-scope="scope">
                <span @click="copyIdToClipboard(scope.row._id)">
                  {{ itemIndex(scope) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="macAddress" label="macAddress" />
            <el-table-column prop="certificateId" label="Certificate Id">
              <template slot-scope="scope">
                <span @click="copyIdToClipboard(scope.row.certificateId)">
                  <abbr :title="scope.row.certificateId">{{
                    scope.row.certificateId
                  }}</abbr>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="customer" label="Customer">
            </el-table-column>
            <el-table-column prop="connectionDate" label="Conn. Duration"  width="140px">
              <template slot-scope="scope">
                <span>
                  {{ dayForm(scope.row.connectionDate) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Connection" width="100">
              <template slot-scope="scope">
                <span>
                  <i
                    class="color-circle"
                    v-bind:style="{
                      'background-color': statusColor(
                        scope.row.connectionStatus
                      ),
                    }"
                  ></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Routings" >
              <template slot-scope="scope">
                <span>
                  <el-button size="mini" @click="showAvaliableDevicesDialog(scope)"
                    >Available Devices</el-button
                  >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="version" label="Version" width="100px;" />

            <el-table-column label="Actions" width="350px">
              <template slot-scope="scope">
               
                <el-popover placement="left-end" width="500" trigger="hover">
                  <p style="white-space: pre-wrap">{{ infoJson(scope.row) }}</p>
                  <el-button
                    style="margin-left: 10px"
                    size="mini"
                    slot="reference"
                    icon="el-icon-info"
                  ></el-button>
                </el-popover>
                <el-button
                  v-if="!editId"
                  size="mini"
                  style="margin-left: 10px"
                  @click="ShowConnectionLogs(scope)"
                  >Connectivity</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
    <el-dialog
      width="30%"
      title="Avaliable Devices"
      :visible.sync="showAvailableDevices"
    >
      <el-table :data="availableDevices" class="border">
        <el-table-column type="index" label="Id">
         <template slot-scope="scope">
            {{(scope.$index+1)+query.pageSize*(query.page-1)}}
            </template>
         </el-table-column>
        <el-table-column prop="_id.device" label="device" />
        <el-table-column prop="_id.gateway" label="gateway" />
        <el-table-column prop="rssi" label="rssi" width="100px;" />
      </el-table>
    </el-dialog>
    <el-dialog
      width="80%"
      :title="connectivityLogTitle"
      :visible.sync="connectivityLogVisible"
      :loading="connectivityLogLoading"
    >
      <Plotly
        @hover="connectivityOnHover"
        :data="connectivityData"
        :layout="layout"
        :display-mode-bar="false"
      ></Plotly>
    </el-dialog>
    <el-dialog width="30%" title="Create Gateway" :visible.sync="showForm">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="130px"
      >
        <el-form-item label="Mac Address" prop="macAddress">
          <div class="el-input">
            <the-mask
              class="el-input__inner"
              v-model="form.macAddress"
              :masked="true"
              mask="FF:FF:FF:FF:FF:FF"
              @input="sanitize($event)"
              :tokens="hexTokens"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="CreateGateway()">Create</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      width="80%"
      :title="connectivityLogTitle"
      :visible.sync="connectivityLogVisible"
      :loading="connectivityLogLoading"
    >
      <Plotly
        @hover="connectivityOnHover"
        :data="connectivityData"
        :layout="layout"
        :display-mode-bar="false"
      ></Plotly>
    </el-dialog>
  </div>
</template>



<script>
import { Plotly } from "vue-plotly";

import { mapState, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";
import beautify from "json-beautify";
import gatewayService from "../service/gateway";
import moment from "moment";

export default {
  name: "Gateway",
  components: { TheMask, Plotly },
  data() {
    let IsMacAddress = (rule, value, callback) => {
      if (
        !/^[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}$/g.test(
          value
        )
      ) {
        return callback(
          new Error("Please input proper mac address (ex: AB:CD:EF:12:34:56)")
        );
      }
      return callback();
    };
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      selectedGateway: "",
      availableDevices: [],
      showAvailableDevices: false,
      query: {
        macAddress: "",
        customer: "",
        version: "",
        connectionStatus: "",
        page: 1,
        pageSize: 10,
      },
      connectivityData: [],
      layout: {
        yaxis:{
          type:"category",
          categoryorder:"category descending"
        },
        margin: {
          r: 50,
          b: 100,
          t: 100,
          pad: 4,
        },
      },
      pageSizes: [10, 25, 50, 75],
      certs: {},
      connectivityLogVisible: false,
      showCertsForm: false,
      filterGateway: null,
      editId: "",
      showForm: false,
      formLoading: false,
      connectivityLogLoading: false,
      connectionStatusSelect: [
        {
          value: "undefined",
          label: `undefined`,
          key: "undefined",
        },
        {
          value: "disconnected",
          label: `disconnected`,
          key: "disconnected",
        },
        {
          value: "connected",
          label: `connected`,
          key: "connected",
        },
      ],
      form: {
        macAddress: "",
        customer: "",
      },
      rules: {
        macAddress: [
          {
            validator: IsMacAddress,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getGateways(this.query);
    this.getCustomers();
  },
  computed: {
    connectivityLogTitle() {
      return (
        "Connectivity log for : " +
        (this.selectedGateway ? this.selectedGateway.macAddress : "")
      );
    },
    ...mapState("gateway", ["searchResult", "loading"]),
    ...mapState("customer", ["customers"]),
    customerFilterSelect() {
      return this.$store.state.customer.customers.map((x) => {
        return {
          value: x._id,
          text: x.name,
        };
      });
    },
    customerSelect() {
      return this.$store.state.customer.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
  },
  methods: {
    showAvaliableDevicesDialog(scope) {
      console.log(scope.row)
      this.availableDevices = scope.row.availableDevices;
      this.showAvailableDevices = true;
    },
    itemIndex(scope) {
      return this.query.pageSize * (this.query.page - 1) + scope.$index + 1;
    },
   
    dayForm(time) {
      if (time == undefined) {
        return "N/A";
      } else {
        return moment(time).fromNow(true);
      }
    },
    infoJson(row) {
      return `${beautify(row, null, 5)}`;
    },
    statusColor(connectionStatus) {
      if (!connectionStatus) {
        return "#ffff00";
      } else if (connectionStatus == "disconnected") {
        return "#ff0000";
      } else if (connectionStatus == "connected") {
        return "#00FF00";
      } else {
        return "#808080";
      }
    },
   
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    ...mapActions("gateway", [
      "getGateways",
      "createGateway",
      "updateGateway",
      "deleteGateway",
      "newCertGateway",
    ]),
    ...mapActions("customer", ["getCustomers"]),
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    connectivityOnHover(event) {
      if (event.points && event.points.length) {
        let point = event.points[0];
        let index = point.pointIndex;
        console.log(index);
        if (index != 0) {
          let prevData = this.connectivityData[0].x[index + 1];
          let current = this.connectivityData[0].x[index];
          console.log(current, prevData);
          console.log(moment(current).diff(prevData, "minutes"));
        }
      }
    },
    ShowConnectionLogs(scope) {
      this.connectivityLogLoading = true;
      this.selectedGateway = scope.row;
      this.connectivityLogVisible = true;
      gatewayService
        .getConnectionLogs(this.selectedGateway._id)
        .then((x) => {
          //todo
          console.log(x);
          let eventTypes = x.map((x) => x.status.eventType);
          let timestamps = x.map((x) => new Date(x.status.timestamp));
          this.connectivityData = [
            {
              x: timestamps,
              y: eventTypes,
              mode: "lines+markers",
              line: { shape: "vh" },
              type: "scatter",
            },
          ];

          console.log(this.connectivityData);
        })
        .finally(() => {
          this.connectivityLogLoading = false;
        });
    },
   
    load() {
      this.getGateways(this.query);
    },
  
   
    UpdateGateway() {
      this.updateGateway({
        _id: this.editId,
        customer: this.form.customer,
      })
        .then(() => {
          this.showForm = false;
        })
        .finally(() => {
          this.editId = "";
          this.form = {
            macAddress: "",
            customer: "",
          };
        });
    },
   
    Cancel() {
      this.editId = "";
      this.form = {
        customer: "",
      };
    },
   

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.color-circle {
  height: 20px;
  width: 20px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>